import React, {useState, useEffect} from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import api from "../Api";
import Popup from "../components/PopUP";


export default function AddAircraft() {
    const [errors, setErrors] = useState({});
    const [manufacturers, setManufacturer] = useState({})
    const [popupMessage, setPopupMessage] = useState("");
    const [seriesList, setSeriesList] = useState([
        { product_series: 'Select', product_description: '' }
    ]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedManufacturerId, setSelectedManufacturerId] = useState('');
    const [selectedManufacturerName, setSelectedManufacturerName] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [images, setImages] = useState([
    { url: "", cc: "", is_default: false, source: "" },
    ]);

    const handleSeriesChange = (index, field, value) => {
        const updatedSeries = [...seriesList];
        updatedSeries[index][field] = value;
        setSeriesList(updatedSeries);
    };

    const addSeries = () => {
        setSeriesList([...seriesList, { product_series: 'Select', product_description: '' }]);
    };

    const removeSeries = (index) => {
        if (seriesList.length > 1) {
        const updatedSeries = seriesList.filter((_, i) => i !== index);
        setSeriesList(updatedSeries);
        }
    };

    // Filter manufacturers based on search query
    const filteredManufacturers = manufacturers.results
        ? manufacturers.results.filter((mfr) =>
            mfr.company_name.toLowerCase().includes(searchQuery.toLowerCase())
        )
        : [];

    // Handle selection of a manufacturer
    const handleManufacturerSelect = (id, name) => {
        setSelectedManufacturerId(id);
        setSelectedManufacturerName(name);
        setSearchQuery(name); // Display selected name in input
        setShowDropdown(false); // Close dropdown after selection
    };

    const formatFieldName = (name) => {
        return name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    };

    
    // image handle
      const handleChange = (index, field, value) => {
                const newImages = [...images];
                newImages[index][field] = field === "is_default" ? value : value;
                setImages(newImages);
            };

            const addImage = () => {
                setImages([...images, { url: "", cc: "", is_default: false, source: "" }]);
            };

            const removeImage = (index) => {
                const newImages = images.filter((_, i) => i !== index);
                setImages(newImages);
            };

     useEffect(() =>{
           const fetchData = async () => {
            try {
            const response = await api.get("/airplane-service/manufacturer/");
            setManufacturer(response.data)
            } catch (error) {
            console.error("API Error:", error.message);
            }
        };
    
        fetchData();
    },[])

    const handleSubmit = async (e) => {
        e.preventDefault();
        const fd = new FormData(e.target);
        const newErrors = {};
        const dataToPost = {};
        const seriesData = [];
        console.log(selectedManufacturerName);

        // Collect all form data
        for (let [key, value] of fd.entries()) {
            // Handle dynamic series fields
            if (key.startsWith('product_series_') || key.startsWith('product_description_')) {
            const [fieldType, index] = key.split('_').slice(1);
            const idx = parseInt(index, 10);

            // Initialize seriesData[idx] if not exists
            if (!seriesData[idx]) {
                seriesData[idx] = { product_series: '', product_description: '' };
            }

            // Assign value to the appropriate field
            if (fieldType === 'series') {
                seriesData[idx].product_series = value;
            } else if (fieldType === 'description') {
                seriesData[idx].product_description = value;
            }
            } else {
            // Handle non-series fields
            if (!value || value === 'Select') {
                newErrors[key] = `The ${formatFieldName(key)} field is required.`;
            } else {
                dataToPost[key] = value;
            }
            }
        }

        // Validate series data
        seriesData.forEach((series, index) => {
            if (!series.product_series || series.product_series === 'Select') {
            newErrors[`product_series_${index}`] = `The Product Series ${index + 1} field is required.`;
            }
            if (!series.product_description) {
            newErrors[`product_description_${index}`] = `The Series Description ${index + 1} field is required.`;
            }
        });

        // Add validated series data to dataToPost
        if (seriesData.length > 0) {
            dataToPost.series = seriesData.filter(
            (series) => series.product_series && series.product_series !== 'Select' && series.product_description
            );
        }

        // Check for errors
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setPopupMessage('Getting validation errors. Please fix and resubmit.');
            return;
        }

        // Clear errors if validation passes
        setErrors({});

        // Prepare API data
        const apiData = new FormData();
        Object.entries(dataToPost).forEach(([key, value]) => {
            if (key === 'series') {
            // Stringify the series array for the API
            apiData.append(key, JSON.stringify(value));
            } else {
            apiData.append(key, value);
            }
        });


        const payload = {
            Identification_Classification: {
                ICAO_Type_Code: fd.get('ICAO_Type_Code'),
                Aircraft_Manufacturer: searchQuery,
                Aircraft_Model: fd.get('Aircraft_Model'),
                Aircraft_Role: fd.get('Aircraft_Role'),
                Aircraft_Type: fd.get('Aircraft_Type'),
                Wake_Turbulence_Category: fd.get('Wake_Turbulence_Category'),
                Civilian_Military_or_Dual_Use: fd.get('Civilian_Military_or_Dual_Use'),
                Country_of_Origin: fd.get('Country_of_Origin'),
                Date_of_Maiden_Flight: fd.get('Date_of_Maiden_Flight'),
                Year_of_Introduction: fd.get('Year_of_Introduction'),
                Production_Status: fd.get('Production_Status'),
                Avionics_System: fd.get('Avionics_System'),
                Number_of_Crew: fd.get('Number_of_Crew'),
                Number_of_Passengers: {
                Typical: fd.get('Number_of_Passengers_Typical'),
                Maximum: fd.get('Number_of_Passengers_Maximum'),
                },
            },
            Powerplant_Propulsion: {
                Number_of_Engines: fd.get('Number_of_Engines'),
                Engine: {
                Manufacturer: fd.get('Engine_Manufacturer'),
                Model: fd.get('Engine_Model'),
                Engine_Type: fd.get('Engine_Type'),
                Thrust_Per_Engine_kN_or_kW: fd.get('Thrust_Per_Engine_kN_or_kW'),
                Physical_Engine_Code: fd.get('Physical_Engine_Code'),
                },
                APU_Type: fd.get('APU_Type'),
                Fuel: {
                Fuel_Type: fd.get('Fuel_Type'),
                Fuel_Additives: fd.get('Fuel_Additives'),
                Capacity_L_or_kg: fd.get('Capacity_L_or_kg'),
                Fuel_Burn_Cruise_kg_per_hr: fd.get('Fuel_Burn_Cruise_kg_per_hr'),
                },
            },
            Dimensions: {
                Wingspan_m: fd.get('Wingspan_m'),
                Wingspan_ft: fd.get('Wingspan_ft'),
                Length_m: fd.get('Length_m'),
                Length_ft: fd.get('Length_ft'),
                Height_m: fd.get('Height_m'),
                Height_ft: fd.get('Height_ft'),
                Wing_Area_m2: fd.get('Wing_Area_m2'),
                Cabin_Width_m: fd.get('Cabin_Width_m'),
                Door_Height_m: fd.get('Door_Height_m'),
                Wingtip_Configuration: fd.get('Wingtip_Configuration'),
            },
            Weights: {
                Operating_Empty_Weight_kg: fd.get('Operating_Empty_Weight_kg'),
                Maximum_Zero_Fuel_Weight_kg: fd.get('Maximum_Zero_Fuel_Weight_kg'),
                Maximum_Takeoff_Weight_kg: fd.get('Maximum_Takeoff_Weight_kg'),
                Maximum_Payload_kg: fd.get('Maximum_Payload_kg'),
                Maximum_Landing_Weight_kg: fd.get('Maximum_Landing_Weight_kg'),
                Baggage_or_Cargo_Volume: {
                Minimum_m3: fd.get('Baggage_or_Cargo_Volume_Minimum_m3'),
                Maximum_m3: fd.get('Baggage_or_Cargo_Volume_Maximum_m3'),
                },
            },
            Performance: {
                Takeoff_Speed_kts: fd.get('Takeoff_Speed_kts'),
                Takeoff_Distance_m: fd.get('Takeoff_Distance_m'),
                Initial_Climb_Rate_fpm: fd.get('Initial_Climb_Rate_fpm'),
                Average_Rate_of_Climb_fpm: fd.get('Average_Rate_of_Climb_fpm'),
                Maximum_Rate_of_Climb_fpm: fd.get('Maximum_Rate_of_Climb_fpm'),
                Service_Ceiling_ft: fd.get('Service_Ceiling_ft'),
                Max_Certified_Altitude_ft: fd.get('Max_Certified_Altitude_ft'),
                Cruise_Speed_kt: fd.get('Cruise_Speed_kt'),
                Cruise_Mach: fd.get('Cruise_Mach'),
                Maximum_Cruise_Speed_kts_or_Mach: fd.get('Maximum_Cruise_Speed_kts_or_Mach'),
                VMO_kts: fd.get('VMO_kts'),
                MMO_Mach: fd.get('MMO_Mach'),
                Range: {
                Normal_Range_NM: fd.get('Normal_Range_NM'),
                Normal_Range_km: fd.get('Normal_Range_km'),
                Ferry_Range_NM: fd.get('Ferry_Range_NM'),
                },
                Initial_Rate_of_Descent_fpm: fd.get('Initial_Rate_of_Descent_fpm'),
                Average_Rate_of_Descent_fpm: fd.get('Average_Rate_of_Descent_fpm'),
                Minimum_Clean_Speed_kts: fd.get('Minimum_Clean_Speed_kts'),
                Approach_Speed_kts: fd.get('Approach_Speed_kts'),
                Approach_Category: fd.get('Approach_Category'),
                Landing_Speed_kts: fd.get('Landing_Speed_kts'),
                Landing_Distance_m: fd.get('Landing_Distance_m'),
                Runway_Length_Required_m: fd.get('Runway_Length_Required_m'),
                Stall_Speed_kts: fd.get('Stall_Speed_kts'),
            },
            Operational_Limitations: {
                Runway_Slope_Limit_percent: fd.get('Runway_Slope_Limit_percent'),
                Max_Crosswind_Normal_Law_kts: fd.get('Max_Crosswind_Normal_Law_kts'),
                Max_Crosswind_Degraded_Law_kts: fd.get('Max_Crosswind_Degraded_Law_kts'),
                Max_Tailwind_Landing_kts: fd.get('Max_Tailwind_Landing_kts'),
                Max_Tailwind_Takeoff_kts: fd.get('Max_Tailwind_Takeoff_kts'),
                Field_Elevation_Limit_ft: fd.get('Field_Elevation_Limit_ft'),
                Max_Runway_Altitude_ft: fd.get('Max_Runway_Altitude_ft'),
                Autoland_Capability: {
                Supported_Categories: fd.get('Autoland_Capability_Supported_Categories'),
                Certified_Autoland_Level: fd.get('Certified_Autoland_Level'),
                },
            },
            Landing_Gear_Configuration: {
                Type: fd.get('Landing_Gear_Type'),
                Number_of_Wheels: fd.get('Number_of_Wheels'),
                Tyre_Size_inches: fd.get('Tyre_Size_inches'),
                Tyre_Pressure_bar_psi: fd.get('Tyre_Pressure_bar_psi'),
            },
            Certification_Environmental: {
                Certification_Basis: fd.get('Certification_Basis'),
                EASA_TCDS_Number: fd.get('EASA_TCDS_Number'),
                FAA_TCDS_Number: fd.get('FAA_TCDS_Number'),
                Special_Conditions: fd.get('Special_Conditions'),
                Noise_Compliance: fd.get('Noise_Compliance'),
                Emissions_Category: fd.get('Emissions_Category'),
            },
            images: images,
            };
         
        console.log(payload)
        try {
            console.log('Posting data to API:', payload);
            const response = await api.post('/airplane-service/aircraft/', payload);
            console.log('API Response:', response);
            setPopupMessage('Aircraft created successfully');
        } catch (error) {
            console.error('API Error:', error.message);
            if (error.response) {
            console.error('API Error Details:', error.response.data);
            setPopupMessage(`Aircraft creation failed: ${error.response.data.message || 'Unknown error'}`);
            } else {
            setPopupMessage('Aircraft creation failed: Network error');
            }
        }
        };
    return(
        <>
        <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
        <Sidebar/>
        <div className="main-wrapper">
      <Header/>

      {/* Content */}
      <div className="content-wrapper">
        <section className="main-section spacer-y">
          <div className="container">
            <div className="row gy-4">
              <div className="col-xl-12">
                <div className="common_main_bg_wrapper">
                  <div className="common_main_heading_wrapper">
                    <div className="vstack">
                      <nav className="breadcrumb_nav">
                        <ul className="breadcrumb mb-0">
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">Dashboard</Link>
                          </li>
                          <li className="breadcrumb-item">
                            <Link to="/challenge-management">
                              Aircraft Management
                            </Link>
                          </li>
                          <li className="breadcrumb-item text-capitalize">
                            Add New Aircraft
                          </li>
                        </ul>
                      </nav>
                      <h1>Aircraft Management</h1>
                    </div>
                    <div className="d-flex flex-end">
                        <Link to="/aircraft" className="secondary_btn">
                        View All Aircraft</Link>
                    </div>
                  </div>
                </div>
                 <form onSubmit={handleSubmit}>
                    {/* Card */}
                    <div className="common-outer-card mt-4">
                        <div className="common_sub_heading_wrapper">
                        <h2>Add New Aircraft</h2>
                        </div>

                        <div className="common_content_blk">
                        <div className="row g-4">
                            {/* Identification_Classification Section */}
                            <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h3>Identification & Classification</h3>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>ICAO Type Code</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter ICAO Type Code"
                                    name="ICAO_Type_Code"
                                />
                                <span className="error">{errors.ICAO_Type_Code}</span>
                                </div>
                            </div>
                            </div>

                            {/* <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Aircraft Manufacturer</label>
                                <div className="input_field">
                                <select className="form-select" name="Aircraft_Manufacturer">
                                    <option value="Select">Select</option>
                                    {manufacturers.results && manufacturers.results.map((mfr) => (
                                        <option key={mfr.id} value={mfr.id}>{mfr.company_name}</option>
                                    ))}
                                </select>
                                <span className="error">{errors.Aircraft_Manufacturer}</span>
                                </div>
                            </div>
                            </div> */}

                            <div className="col-12 col-sm-6 col-md-4">
                                <div className="form_field">
                                    <label>Aircraft Manufacturer</label>
                                    <div className="input_field">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Manufacturer..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        onFocus={() => setShowDropdown(true)}
                                        onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                                    />
                                    {showDropdown && (
                                        <ul className="dropdown-menu show" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                        {filteredManufacturers.length > 0 ? (
                                            filteredManufacturers.map((mfr) => (
                                            <li
                                                key={mfr.id}
                                                className="dropdown-item"
                                                style={{ cursor: 'pointer' }}
                                                onMouseDown={() => handleManufacturerSelect(mfr.id, mfr.company_name)}
                                            >
                                                {mfr.company_name}
                                            </li>
                                            ))
                                        ) : (
                                            <li className="dropdown-item disabled">No manufacturers found</li>
                                        )}
                                        </ul>
                                    )}
                                    <input
                                        type="hidden"
                                        name="Aircraft_Manufacturer"
                                        value={selectedManufacturerId}
                                    />
                                    <span className="error">{errors.Aircraft_Manufacturer}</span>
                                    </div>
                                </div>
                                </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Aircraft Model</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Aircraft Model"
                                    name="Aircraft_Model"
                                />
                                <span className="error">{errors.Aircraft_Model}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Aircraft Role</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Aircraft Role"
                                    name="Aircraft_Role"
                                />
                                <span className="error">{errors.Aircraft_Role}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Aircraft Type</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Aircraft Type"
                                    name="Aircraft_Type"
                                />
                                <span className="error">{errors.Aircraft_Type}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Wake Turbulence Category</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Wake Turbulence Category"
                                    name="Wake_Turbulence_Category"
                                />
                                <span className="error">{errors.Wake_Turbulence_Category}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Civilian, Military, or Dual Use</label>
                                <div className="input_field">
                                <select className="form-select" name="Civilian_Military_or_Dual_Use">
                                    <option value="Select">Select</option>
                                    <option value="Civil">Civil</option>
                                    <option value="Military">Military</option>
                                    <option value="Dual">Dual</option>
                                </select>
                                <span className="error">{errors.Civilian_Military_or_Dual_Use}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Country of Origin</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Country of Origin"
                                    name="Country_of_Origin"
                                />
                                <span className="error">{errors.Country_of_Origin}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Date of Maiden Flight</label>
                                <div className="input_field">
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="Enter Date of Maiden Flight"
                                    name="Date_of_Maiden_Flight"
                                />
                                {/* <span className="info">Please enter in this format: 14 June 2013</span> */}
                                <span className="error">{errors.Date_of_Maiden_Flight}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Year of Introduction</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Year of Introduction"
                                    name="Year_of_Introduction"
                                />
                                <span className="error">{errors.Year_of_Introduction}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Production Status</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Production Status"
                                    name="Production_Status"
                                />
                                <span className="error">{errors.Production_Status}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Avionics System</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Avionics System"
                                    name="Avionics_System"
                                />
                                <span className="error">{errors.Avionics_System}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Number of Crew</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Number of Crew"
                                    name="Number_of_Crew"
                                />
                                <span className="error">{errors.Number_of_Crew}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Typical Number of Passengers</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Typical Number of Passengers"
                                    name="Number_of_Passengers_Typical"
                                />
                                <span className="error">{errors.Number_of_Passengers_Typical}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Maximum Number of Passengers</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Maximum Number of Passengers"
                                    name="Number_of_Passengers_Maximum"
                                />
                                <span className="error">{errors.Number_of_Passengers_Maximum}</span>
                                </div>
                            </div>
                            </div>

                            {/* Powerplant_Propulsion Section */}
                            <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h3>Powerplant & Propulsion</h3>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Number of Engines</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Number of Engines"
                                    name="Number_of_Engines"
                                />
                                <span className="error">{errors.Number_of_Engines}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Engine Manufacturer</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Engine Manufacturer"
                                    name="Engine_Manufacturer"
                                />
                                <span className="error">{errors.Engine_Manufacturer}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Engine Model</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Engine Model"
                                    name="Engine_Model"
                                />
                                <span className="error">{errors.Engine_Model}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Engine Type</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Engine Type"
                                    name="Engine_Type"
                                />
                                <span className="error">{errors.Engine_Type}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Thrust Per Engine (kN or kW)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Thrust Per Engine"
                                    name="Thrust_Per_Engine_kN_or_kW"
                                />
                                <span className="error">{errors.Thrust_Per_Engine_kN_or_kW}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Physical Engine Code</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Physical Engine Code"
                                    name="Physical_Engine_Code"
                                />
                                <span className="error">{errors.Physical_Engine_Code}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>APU Type</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter APU Type"
                                    name="APU_Type"
                                />
                                <span className="error">{errors.APU_Type}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Fuel Type</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Fuel Type"
                                    name="Fuel_Type"
                                />
                                <span className="error">{errors.Fuel_Type}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Fuel Additives</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Fuel Additives"
                                    name="Fuel_Additives"
                                />
                                <span className="error">{errors.Fuel_Additives}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Fuel Capacity (L or kg)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Fuel Capacity"
                                    name="Capacity_L_or_kg"
                                />
                                <span className="error">{errors.Capacity_L_or_kg}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Fuel Burn Cruise (kg/hr)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Fuel Burn Cruise"
                                    name="Fuel_Burn_Cruise_kg_per_hr"
                                />
                                <span className="error">{errors.Fuel_Burn_Cruise_kg_per_hr}</span>
                                </div>
                            </div>
                            </div>

                            {/* <!-- Dimensions Section --> */}
                            <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h3>Dimensions</h3>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Wingspan (m)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Wingspan (m)"
                                    name="Wingspan_m"
                                />
                                <span className="error">{errors.Wingspan_m}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Wingspan (ft)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Wingspan (ft)"
                                    name="Wingspan_ft"
                                />
                                <span className="error">{errors.Wingspan_ft}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Length (m)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Length (m)"
                                    name="Length_m"
                                />
                                <span className="error">{errors.Length_m}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Length (ft)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Length (ft)"
                                    name="Length_ft"
                                />
                                <span className="error">{errors.Length_ft}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Height (m)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Height (m)"
                                    name="Height_m"
                                />
                                <span className="error">{errors.Height_m}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Height (ft)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Height (ft)"
                                    name="Height_ft"
                                />
                                <span className="error">{errors.Height_ft}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Wing Area (m²)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Wing Area (m²)"
                                    name="Wing_Area_m2"
                                />
                                <span className="error">{errors.Wing_Area_m2}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Cabin Width (m)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Cabin Width (m)"
                                    name="Cabin_Width_m"
                                />
                                <span className="error">{errors.Cabin_Width_m}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Door Height (m)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Door Height (m)"
                                    name="Door_Height_m"
                                />
                                <span className="error">{errors.Door_Height_m}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Wingtip Configuration</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Wingtip Configuration"
                                    name="Wingtip_Configuration"
                                />
                                <span className="error">{errors.Wingtip_Configuration}</span>
                                </div>
                            </div>
                            </div>

                            {/* <!-- Weights Section --> */}
                            <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h3>Weights</h3>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Operating Empty Weight (kg)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Operating Empty Weight"
                                    name="Operating_Empty_Weight_kg"
                                />
                                <span className="error">{errors.Operating_Empty_Weight_kg}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Maximum Zero Fuel Weight (kg)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Maximum Zero Fuel Weight"
                                    name="Maximum_Zero_Fuel_Weight_kg"
                                />
                                <span className="error">{errors.Maximum_Zero_Fuel_Weight_kg}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Maximum Takeoff Weight (kg)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Maximum Takeoff Weight"
                                    name="Maximum_Takeoff_Weight_kg"
                                />
                                <span className="error">{errors.Maximum_Takeoff_Weight_kg}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Maximum Payload (kg)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Maximum Payload"
                                    name="Maximum_Payload_kg"
                                />
                                <span className="error">{errors.Maximum_Payload_kg}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Maximum Landing Weight (kg)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Maximum Landing Weight"
                                    name="Maximum_Landing_Weight_kg"
                                />
                                <span className="error">{errors.Maximum_Landing_Weight_kg}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Minimum Baggage/Cargo Volume (m³)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Minimum Baggage/Cargo Volume"
                                    name="Baggage_or_Cargo_Volume_Minimum_m3"
                                />
                                <span className="error">{errors.Baggage_or_Cargo_Volume_Minimum_m3}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Maximum Baggage/Cargo Volume (m³)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Maximum Baggage/Cargo Volume"
                                    name="Baggage_or_Cargo_Volume_Maximum_m3"
                                />
                                <span className="error">{errors.Baggage_or_Cargo_Volume_Maximum_m3}</span>
                                </div>
                            </div>
                            </div>

                            {/* <!-- Performance Section --> */}
                            <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h3>Performance</h3>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Takeoff Speed (kts)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Takeoff Speed"
                                    name="Takeoff_Speed_kts"
                                />
                                <span className="error">{errors.Takeoff_Speed_kts}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Takeoff Distance (m)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Takeoff Distance"
                                    name="Takeoff_Distance_m"
                                />
                                <span className="error">{errors.Takeoff_Distance_m}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Initial Climb Rate (fpm)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Initial Climb Rate"
                                    name="Initial_Climb_Rate_fpm"
                                />
                                <span className="error">{errors.Initial_Climb_Rate_fpm}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Average Rate of Climb (fpm)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Average Rate of Climb"
                                    name="Average_Rate_of_Climb_fpm"
                                />
                                <span className="error">{errors.Average_Rate_of_Climb_fpm}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Maximum Rate of Climb (fpm)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Maximum Rate of Climb"
                                    name="Maximum_Rate_of_Climb_fpm"
                                />
                                <span className="error">{errors.Maximum_Rate_of_Climb_fpm}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Service Ceiling (ft)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Service Ceiling"
                                    name="Service_Ceiling_ft"
                                />
                                <span className="error">{errors.Service_Ceiling_ft}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Max Certified Altitude (ft)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Max Certified Altitude"
                                    name="Max_Certified_Altitude_ft"
                                />
                                <span className="error">{errors.Max_Certified_Altitude_ft}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Cruise Speed (kt)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Cruise Speed"
                                    name="Cruise_Speed_kt"
                                />
                                <span className="error">{errors.Cruise_Speed_kt}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Cruise Mach</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Cruise Mach"
                                    name="Cruise_Mach"
                                />
                                <span className="error">{errors.Cruise_Mach}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Maximum Cruise Speed (kts or Mach)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Maximum Cruise Speed"
                                    name="Maximum_Cruise_Speed_kts_or_Mach"
                                />
                                <span className="error">{errors.Maximum_Cruise_Speed_kts_or_Mach}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>VMO (kts)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter VMO"
                                    name="VMO_kts"
                                />
                                <span className="error">{errors.VMO_kts}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>MMO (Mach)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter MMO"
                                    name="MMO_Mach"
                                />
                                <span className="error">{errors.MMO_Mach}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Normal Range (NM)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Normal Range (NM)"
                                    name="Normal_Range_NM"
                                />
                                <span className="error">{errors.Normal_Range_NM}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Normal Range (km)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Normal Range (km)"
                                    name="Normal_Range_km"
                                />
                                <span className="error">{errors.Normal_Range_km}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Ferry Range (NM)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Ferry Range (NM)"
                                    name="Ferry_Range_NM"
                                />
                                <span className="error">{errors.Ferry_Range_NM}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Initial Rate of Descent (fpm)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Initial Rate of Descent"
                                    name="Initial_Rate_of_Descent_fpm"
                                />
                                <span className="error">{errors.Initial_Rate_of_Descent_fpm}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Average Rate of Descent (fpm)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Average Rate of Descent"
                                    name="Average_Rate_of_Descent_fpm"
                                />
                                <span className="error">{errors.Average_Rate_of_Descent_fpm}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Minimum Clean Speed (kts)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Minimum Clean Speed"
                                    name="Minimum_Clean_Speed_kts"
                                />
                                <span className="error">{errors.Minimum_Clean_Speed_kts}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Approach Speed (kts)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Approach Speed"
                                    name="Approach_Speed_kts"
                                />
                                <span className="error">{errors.Approach_Speed_kts}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Approach Category</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Approach Category"
                                    name="Approach_Category"
                                />
                                <span className="error">{errors.Approach_Category}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Landing Speed (kts)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Landing Speed"
                                    name="Landing_Speed_kts"
                                />
                                <span className="error">{errors.Landing_Speed_kts}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Landing Distance (m)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Landing Distance"
                                    name="Landing_Distance_m"
                                />
                                <span className="error">{errors.Landing_Distance_m}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Runway Length Required (m)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Runway Length Required"
                                    name="Runway_Length_Required_m"
                                />
                                <span className="error">{errors.Runway_Length_Required_m}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Stall Speed (kts)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Stall Speed"
                                    name="Stall_Speed_kts"
                                />
                                <span className="error">{errors.Stall_Speed_kts}</span>
                                </div>
                            </div>
                            </div>

                            {/* <!-- Operational_Limitations Section --> */}
                            <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h3>Operational Limitations</h3>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Runway Slope Limit (%)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Runway Slope Limit"
                                    name="Runway_Slope_Limit_percent"
                                />
                                <span className="error">{errors.Runway_Slope_Limit_percent}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Max Crosswind Normal Law (kts)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Max Crosswind Normal Law"
                                    name="Max_Crosswind_Normal_Law_kts"
                                />
                                <span className="error">{errors.Max_Crosswind_Normal_Law_kts}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Max Crosswind Degraded Law (kts)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Max Crosswind Degraded Law"
                                    name="Max_Crosswind_Degraded_Law_kts"
                                />
                                <span className="error">{errors.Max_Crosswind_Degraded_Law_kts}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Max Tailwind Landing (kts)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Max Tailwind Landing"
                                    name="Max_Tailwind_Landing_kts"
                                />
                                <span className="error">{errors.Max_Tailwind_Landing_kts}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Max Tailwind Takeoff (kts)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Max Tailwind Takeoff"
                                    name="Max_Tailwind_Takeoff_kts"
                                />
                                <span className="error">{errors.Max_Tailwind_Takeoff_kts}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Field Elevation Limit (ft)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Field Elevation Limit"
                                    name="Field_Elevation_Limit_ft"
                                />
                                <span className="error">{errors.Field_Elevation_Limit_ft}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Max Runway Altitude (ft)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Max Runway Altitude"
                                    name="Max_Runway_Altitude_ft"
                                />
                                <span className="error">{errors.Max_Runway_Altitude_ft}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Autoland Supported Categories</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Autoland Supported Categories"
                                    name="Autoland_Capability_Supported_Categories"
                                />
                                <span className="error">{errors.Autoland_Capability_Supported_Categories}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Certified Autoland Level</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Certified Autoland Level"
                                    name="Certified_Autoland_Level"
                                />
                                <span className="error">{errors.Certified_Autoland_Level}</span>
                                </div>
                            </div>
                            </div>

                            {/* <!-- Landing_Gear_Configuration Section --> */}
                            <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h3>Landing Gear Configuration</h3>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Landing Gear Type</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Landing Gear Type"
                                    name="Landing_Gear_Type"
                                />
                                <span className="error">{errors.Landing_Gear_Type}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Number of Wheels</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Number of Wheels"
                                    name="Number_of_Wheels"
                                />
                                <span className="error">{errors.Number_of_Wheels}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Tyre Size (inches)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Tyre Size"
                                    name="Tyre_Size_inches"
                                />
                                <span className="error">{errors.Tyre_Size_inches}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Tyre Pressure (bar/psi)</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Tyre Pressure"
                                    name="Tyre_Pressure_bar_psi"
                                />
                                <span className="error">{errors.Tyre_Pressure_bar_psi}</span>
                                </div>
                            </div>
                            </div>

                            {/* <!-- Certification_Environmental Section --> */}
                            <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h3>Certification & Environmental</h3>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Certification Basis</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Certification Basis"
                                    name="Certification_Basis"
                                />
                                <span className="error">{errors.Certification_Basis}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>EASA TCDS Number</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter EASA TCDS Number"
                                    name="EASA_TCDS_Number"
                                />
                                <span className="error">{errors.EASA_TCDS_Number}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>FAA TCDS Number</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter FAA TCDS Number"
                                    name="FAA_TCDS_Number"
                                />
                                <span className="error">{errors.FAA_TCDS_Number}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Special Conditions</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Special Conditions"
                                    name="Special_Conditions"
                                />
                                <span className="error">{errors.Special_Conditions}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Noise Compliance</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Noise Compliance"
                                    name="Noise_Compliance"
                                />
                                <span className="error">{errors.Noise_Compliance}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                                <label>Emissions Category</label>
                                <div className="input_field">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Emissions Category"
                                    name="Emissions_Category"
                                />
                                <span className="error">{errors.Emissions_Category}</span>
                                </div>
                            </div>
                            </div>

                            {/* <!-- Additional Information Section --> */}
                            <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h3>Additional Information</h3>
                            </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12">
                            <div className="form_field">
                                <label>Company/Manufacturer Description</label>
                                <div className="input_field">
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Write something...."
                                    name="company_description"
                                ></textarea>
                                <span className="error">{errors.company_description}</span>
                                </div>
                            </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12">
                            <div className="form_field">
                                <label>Company/Manufacturer History</label>
                                <div className="input_field">
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Write something...."
                                    name="company_history"
                                ></textarea>
                                <span className="error">{errors.company_history}</span>
                                </div>
                            </div>
                            </div>

                           <div className="col-12">
                            {seriesList.map((series, index) => (
                            <div className="row g-4" key={index}>
                                <div className="col-12 col-sm-6 col-md-4">
                                <div className="form_field">
                                    <label>Product Series {index + 1}</label>
                                    <div className="input_field">
                                    <select
                                        className="form-select"
                                        name={`product_series_${index}`}
                                        value={series.product_series}
                                        onChange={(e) => handleSeriesChange(index, 'product_series', e.target.value)}
                                    >
                                        <option value="Select">Select</option>
                                        <option value="Civilian">Civilian</option>
                                        <option value="Military">Military</option>
                                    </select>
                                    <span className="error">{errors[`product_series_${index}`]}</span>
                                    </div>
                                </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-6">
                                <div className="form_field">
                                    <label>Series Description {index + 1}</label>
                                    <div className="input_field">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Describe about series ..."
                                        name={`product_description_${index}`}
                                        value={series.product_description}
                                        onChange={(e) => handleSeriesChange(index, 'product_description', e.target.value)}
                                    />
                                    <span className="error">{errors[`product_description_${index}`]}</span>
                                    </div>
                                </div>
                                </div>

                                <div className="col-12 col-sm-1 col-md-2">
                                <div className="form_field mt-md-5 mb-0 mb-3" >
                                    <button
                                    type="button"
                                    className="btn btn-danger text-white rounded-pill"
                                    onClick={() => removeSeries(index)}
                                    disabled={seriesList.length === 1}
                                    >
                                    Remove
                                    </button>
                                </div>
                                </div>
                            </div>
                            ))}
                           </div>

                            <div className="col-12">
                            <div className="form_field">
                                <button
                                type="button"
                                className="primary-btn rounded-pill"
                                onClick={addSeries}
                                >
                                Add Series
                                </button>
                            </div>
                            </div>
                            {/* <!-- Images Section --> */}
                            <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h3>Images</h3>
                            </div>
                            </div>

                            {/* <div className="col-12 col-sm-12 col-md-12">
                            <div className="form_field">
                                <label>Image URLs (JSON List)</label>
                                <div className="input_field">
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter Image URLs (comma-separated)"
                                    name="image_urls"
                                ></textarea>
                                <span className="error">{errors.image_urls}</span>
                                </div>
                            </div>
                            </div> */}
                            
                            <div className="col-12 col-sm-12 col-md-12">
                                <div className="form_field">
                                    <label>Image URLs (Multiple)</label>
                                    <div className="row g-3">
                                        {images.map((img, index) => (
                                       <>
                                        <div className="col-12 col-sm-6 col-lg-4">
                                            <div key={index} className="input_field mb-2 p-2">
                                                <input
                                                className="form-control mb-1"
                                                type="text"
                                                placeholder="URL"
                                                value={img.url}
                                                onChange={(e) => handleChange(index, "url", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-4">
                                            <div key={index} className="input_field mb-2 p-2">
                                                <input
                                                className="form-control mb-1"
                                                type="text"
                                                placeholder="Credit / CC"
                                                value={img.cc}
                                                onChange={(e) => handleChange(index, "cc", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-4">
                                            <div key={index} className="input_field mb-2 p-2">
                                                <input
                                                className="form-control mb-1"
                                                type="text"
                                                placeholder="Source"
                                                value={img.source}
                                                onChange={(e) => handleChange(index, "source", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="hstack justify-content-between gap-2">
                                                <label className="mb-0">
                                            <input
                                                type="checkbox"
                                                checked={img.is_default}
                                                onChange={(e) => handleChange(index, "is_default", e.target.checked)}
                                            />{" "}
                                            Default
                                            </label>
                                            <button
                                            type="button"
                                            className="btn btn-danger btn-sm mt-1"
                                            onClick={() => removeImage(index)}
                                            >
                                            Remove
                                            </button>
                                            </div>
                                        </div>
                                       </>
                                        ))}
                                        </div>
                                    <button type="button" className="btn btn-primary mt-3" onClick={addImage}>
                                    Add Image
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="main_action_blk hstack justify-content-start">
                            <button className="bg_primary_outline_btn rounded-pill">
                            Cancel
                            </button>
                            <button className="primary-btn rounded-pill">
                            Save
                            </button>
                        </div>
                        </div>
                    </div>
                    {/* <!-- End card --> */}
                    </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
        </>
    )

}